import React from 'react'
import './clients.css'

import IMG1 from '../../../assets/images/clients/McDonalds.png'
import IMG2 from '../../../assets/images/clients/jiffy_lube.png'
import IMG3 from '../../../assets/images/clients/fedex.png'
import IMG4 from '../../../assets/images/clients/urban_air.png'
import IMG5 from '../../../assets/images/clients/office_depot.png'
import IMG6 from '../../../assets/images/clients/pf.png'
import IMG7 from '../../../assets/images/clients/bh.png'
import IMG8 from '../../../assets/images/clients/lr.png'
import IMG9 from '../../../assets/images/clients/jw.png'
import IMG10 from '../../../assets/images/clients/hersheys.png'
import IMG11 from '../../../assets/images/clients/dell.png'
import IMG12 from '../../../assets/images/clients/dannon.png'



const data = [
  {
    id: 1,
    image: IMG1,
    title: "Mc Donald's"
  },
  {
    id: 2,
    image: IMG2,
    title: "Jiffy Lube"
  },
  {
    id: 3,
    image: IMG3,
    title: "Fed EX"
  },
  {
    id: 4,
    image: IMG4,
    title: "Urban Air Lube"
  },
  {
    id: 5,
    image: IMG5,
    title: "Office Depot"
  },
  {
    id: 6,
    image: IMG6,
    title: "Johnie Walker"
  },
  {
    id: 7,
    image: IMG7,
    title: "Baptist Health"
  },
  {
    id: 8,
    image: IMG8,
    title: "Johnie Walker"
  },
  {
    id: 9,
    image: IMG9,
    title: "Johnie Walker"
  },
  {
    id: 10,
    image: IMG10,
    title: "Hershey's"
  },
  {
    id: 11,
    image: IMG11,
    title: "Dell"
  },
  {
    id: 12,
    image: IMG12,
    title: "Dannon"
  },


];
const Clients = () => {
  return (
    <section id="past-clients">
      <div className="container clients__container">
        <div className="animationGroup autoShow">
          <h5>Some Past Clients</h5>
          <h2>Who I've Worked With</h2>
        </div>
        <div className="client__cards">
          {
            data.map(({ id, image, title }) => {
              return (
                <div key={id} className='client__card imageShow'>
                  <div className="client__logo">
                    <img src={image} alt={title} />
                  </div>
                </div>
              )
            })
          }


        </div>
      </div>
    </section>
  )
}

export default Clients